import { errorByCode } from "./errors";
import { db } from "./app";

export async function fetch({ id }) {
  let doc = await db
    .collection("modelExports")
    .doc(id)
    .get();

  doc = doc || {};

  if (doc.exists) {
    return { id: doc.id, ...doc.data() };
  } else {
    return null;
  }
}

export function* create(params) {
  let error;
  let modelExport;
  let ref;

  try {
    ref = yield db.collection("modelExports").add(params);
    modelExport = {
      id: ref.id,
      createdAt: Date.now(),
      ...params
    };
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error, modelExport };
}

export default {
  fetch,
  create
};



// WEBPACK FOOTER //
// ./src/services/firebase/modelExport.js